import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import HmAjax from '../../util/HmAjax';
import Stepper from 'react-stepper-horizontal';

class HorizontalStepper extends LoggedInPage{
  constructor(props){
    super(props);
      this.state = {
        steps: [{
          title: '',
        }, {
          title: '',
        }, {
          title: '',
        }, {
          title: '',
        }, {
          title: '',
        }, {
          title: '',
        }, {
          title: '',
        }, {
          title: '',
        }],
        currentStep: 0,
        stepLoaded: true
      };
      this.onClickNext = this.onClickNext.bind(this);
    }
    componentDidMount(){
        this.setState({
            stepLoaded: true,
            currentStep: (!isNaN(this.props.currentStep) && this.props.currentStep > 1) ? this.currentStep-1 : 0
        })
        this.onClickNext();
    }
  
    onClickNext() {
      const { steps, currentStep } = this.state;
      this.setState({
        currentStep: currentStep + 1,
      });
    }
   
    render() {
      const { steps, currentStep } = this.state;
      const buttonStyle = { background: '#E0E0E0', width: 200, padding: 16, textAlign: 'center', margin: '0 auto', marginTop: 32 };
  
      return (
        <div>
          <Stepper steps={ steps } loaded ={this.state.stepLoaded} activeStep={ (!isNaN(this.props.currentStep) && this.props.currentStep > 1) ? this.props.currentStep-1 : this.state.currentStep } completeColor='#46C368' activeColor='#FF9300' defaultColor='#A3A3A3' 
           defaultBorderWidth={2} completeBarColor='#b0b0b0' titleFontSize={14}
          />
           {/* <div style={ buttonStyle } onClick={ this.onClickNext }>Next</div>  */}
        </div>
      );
    }
  };
  

export default HorizontalStepper;


// WEBPACK FOOTER //
// ./src/views/contest/HorizontalStepper.js